import {
  collection, onSnapshot, doc, addDoc, updateDoc, query, orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import type { Breed } from "../lib/types";

const breedsCol = () => collection(db, "breeds");

export function subscribeBreeds(
  onData: (breeds: Breed[]) => void,
  onError: (e: Error) => void,
): () => void {
  return onSnapshot(
    query(breedsCol(), orderBy("name")),
    (snap) => {
      const out: Breed[] = snap.docs.map((d) => {
        const r = d.data();
        return {
          id: d.id,
          name: typeof r.name === "string" ? r.name : "",
          appointmentMinutes: typeof r.appointmentMinutes === "number" ? r.appointmentMinutes : 60,
          dailyMax: typeof r.dailyMax === "number" ? r.dailyMax : 1,
          active: r.active !== false,
        };
      });
      onData(out);
    },
    (err) => onError(err),
  );
}

export async function addBreed(b: Omit<Breed, "id">): Promise<void> {
  await addDoc(breedsCol(), b);
}

export async function updateBreed(id: string, patch: Partial<Omit<Breed, "id">>): Promise<void> {
  await updateDoc(doc(db, "breeds", id), patch);
}

// Breeds are retired (active=false), never deleted, so booking history stays intact.
export async function retireBreed(id: string): Promise<void> {
  await updateDoc(doc(db, "breeds", id), { active: false });
}

export async function reactivateBreed(id: string): Promise<void> {
  await updateDoc(doc(db, "breeds", id), { active: true });
}
